export default () => {
  return [
    {
      imgUrl: require("@/assets/images/product/12.png"),
      title: "电子招采交易平台",
    },
    {
      imgUrl: require("@/assets/images/product/1.png"),
      title: "广联达-GEPS产品的二开项目",
    },
    {
      imgUrl: require("@/assets/images/product/2.png"),
      title: "龙华区公共资源交易-智能化监管系统",
    },
    {
      imgUrl: require("@/assets/images/product/3.png"),
      title: "基层治理平台",
    },
    {
      imgUrl: require("@/assets/images/product/4.png"),
      title: "数澜科技-方太项目",
    },
    {
      imgUrl: require("@/assets/images/product/5.png"),
      title: "传话支付-物流钱包",
    },
    {
      imgUrl: require("@/assets/images/product/6.png"),
      title: "兴业消费金融项目",
    },
    {
      imgUrl: require("@/assets/images/product/7.png"),
      title: "金顶控股-IT战略规划咨询项目",
    },
    {
      imgUrl: require("@/assets/images/product/8.png"),
      title: "兴业银行-钱大掌柜",
    },
    {
      imgUrl: require("@/assets/images/product/9.png"),
      title: "连连支付-美国运通一卡通世界",
    },
    {
      imgUrl: require("@/assets/images/product/10.png"),
      title: "常欲控股-智能CRM",
    },
    {
      imgUrl: require("@/assets/images/product/11.png"),
      title: "融顶网络-互联网保险",
    },
  ];
};
